import { render, staticRenderFns } from "./priSettingsControlGroupPopulation.vue?vue&type=template&id=6c283f7a&scoped=true"
import script from "./priSettingsControlGroupPopulation.vue?vue&type=script&lang=js"
export * from "./priSettingsControlGroupPopulation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c283f7a",
  null
  
)

export default component.exports